import React, { useCallback, useEffect, useState } from "react";
import { ApplicationStatusControlled } from "./application-status-controlled";
import {
  ApplicationManageData,
  JobScheduleDetails,
  NheStatus,
  SdaInfo,
} from "../../utility/application-data";
import { NHEAppointmentStatusEnum } from "../appointment-card/card-controlled";
import dayjs from "dayjs";

interface ApplicationStatusUncontrolledProps {
  sdaAccessor: () => Promise<SdaInfo | undefined>;
  nheAccessor: () => Promise<NheStatus | undefined>;
  jcAccessor: () => Promise<JobScheduleDetails | undefined>;
  applicationManageAccessor: () => Promise<ApplicationManageData | undefined>;
}

const nheIncompleteApplicationStates = ["EVALUATION_PENDING", "APPT_1_PENDING"];

export const ApplicationStatusUncontrolled = ({
  sdaAccessor,
  nheAccessor,
  jcAccessor,
  applicationManageAccessor,
}: ApplicationStatusUncontrolledProps) => {
  const [startDateStatus, setStartDateStatus] = useState<string | undefined>();
  const [nheStatus, setNheStatus] = useState<boolean | undefined>();
  const [afterFirstDay, setAfterFirstDay] = useState<boolean | undefined>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<boolean>(false);

  const requestNheStatusAndStartDateStatus = useCallback(async () => {
    setLoading(true);
    try {
      const sdaDetails = await sdaAccessor();
      const nheDetails = await nheAccessor();
      const jcDetails = await jcAccessor();

      const applicationManageDetails = await applicationManageAccessor();
      if (sdaDetails?.errorCode || jcDetails?.error) {
        setError(true);
      } else {
        setStartDateStatus(sdaDetails?.startDateStatus);
        if (
          nheDetails?.status === NHEAppointmentStatusEnum.COMPLETED ||
          (nheDetails?.status !== NHEAppointmentStatusEnum.RESERVED &&
            applicationManageDetails?.applicationState &&
            !nheIncompleteApplicationStates.includes(
              applicationManageDetails.applicationState
            ))
        ) {
          setNheStatus(true);
        } else {
          setNheStatus(false);
        }

        const firstDayOnSite = jcDetails?.firstDayOnSite;
        if (
          firstDayOnSite !== undefined &&
          dayjs().isAfter(dayjs(firstDayOnSite))
        ) {
          setAfterFirstDay(true);
        } else {
          setAfterFirstDay(false);
        }
        setError(false);
      }
    } catch (e) {
      setError(true);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    requestNheStatusAndStartDateStatus();
  }, []);

  return (
    <ApplicationStatusControlled
      startDateStatus={startDateStatus}
      nheCompleted={nheStatus}
      afterFirstDay={afterFirstDay}
      loading={loading}
      error={error}
    />
  );
};
